import React from "react";
import ProductDisplay from "./ProductDisplay";
import { Product } from "../../Interfaces/Product";
import { FundraiserParticipantShop } from "../../Interfaces/FundraiserRole";

const Products: React.FC<{
  products: Product[];
  participant: FundraiserParticipantShop;
}> = ({ products, participant }) => {
  return (
    <div className="products">
      {products.map((product) => (
        <ProductDisplay
          key={product?.sku}
          product={product!}
          participant={participant}
        />
      ))}
    </div>
  );
};

export default Products;
